<ng-template #rt let-listEntry="result" let-t="term">
  <ng-container
    [ngTemplateOutlet]="(listEntry.hasOtherInformation()) ? hasInfo : noInfo"
    [ngTemplateOutletContext]="{entry: listEntry}">
  </ng-container>
</ng-template>

<ng-template #hasInfo let-entry="entry">
  <ul class="list-unstyled mb-0">
    <li class="list-item d-flex align-items-center">
      @if (entry.source) {
        <img class="source-icon" #imgTag [src]="getAuthoritySourceIcon(entry.source, imgTag)" [attr.alt]="('form.entry.source.' + entry.source) | translate" />
      }
      <div class="ms-2 text-truncate text-primary fw-bold">{{entry.value}}</div>
    </li>
    @for (item of entry.otherInformation | dsObjNgFor; track item) {
      @if(!item.key.startsWith('data-')) {
        <li class="list-item text-truncate text-secondary" >
          {{ 'form.other-information.' + item.key | translate }} : {{item.value}}
        </li>
      }
    }
  </ul>
</ng-template>

<ng-template #noInfo let-entry="entry">
  <ul class="list-unstyled mb-0">
    <li class="list-item d-flex align-items-center">
      @if(entry.source) {
        <img class="source-icon" #imgTag [src]="getAuthoritySourceIcon(entry.source, imgTag)" [attr.alt]="('form.entry.source.' + entry.source) | translate" />
      }
      <div class="ms-2 text-truncate text-primary font-weight-bold">{{entry.value}}</div>
      @if(entry.source) {
        <div class="ml-2 text-truncate text-secondary">{{ ('form.entry.source.' + entry.source) | translate}}</div>
      }
    </li>
  </ul>
</ng-template>

@if ((isHierarchicalVocabulary() | async) !== true) {
  <div class="form-row position-relative align-items-center">

    <div class="position-relative right-addon">
      <div class="authority-icons position-absolute d-flex align-items-center">
        @if (searching || loadingInitialValue) {
          <i class="fas fa-circle-notch fa-spin fa-2x fa-fw text-primary my-auto p-0" aria-hidden="true"></i>
        }
        @if (!searching && !loadingInitialValue) {
          <i
            dsAuthorityConfidenceState
            class="far fa-circle fa-2x fa-fw my-auto p-0"
            aria-hidden="true"
            [authorityValue]="currentValue"
            (whenClickOnConfidenceNotAccepted)="whenClickOnConfidenceNotAccepted($event)"></i>
        }
        @if(otherInfoValues.length > 0 && (model.id === otherInfoKey || otherInfoKey === alternativeNamesKey || 'data-' + model.id === otherInfoKey)) {
          <i
            class="fa-solid fa-angle-down fa-fw fa-2x fa-fw position-absolute mt-1 p-0 additional-items-icon"
            aria-hidden="true"
            (click)="toggleOtherInfoSelection()"
          ></i>
        }
      </div>
      <input #instance="ngbTypeahead"
             class="form-control"
             [attr.aria-labelledby]="'label_' + model.id"
             [attr.autoComplete]="model.autoComplete"
             [attr.aria-label]="(model.label || model?.additional?.ariaLabel) | translate"             [class.is-invalid]="showErrorMessages"
             [id]="model.id"
             [inputFormatter]="formatter"
             [name]="model.name"
             [ngbTypeahead]="search"
             [placeholder]="model.placeholder"
             [readonly]="model.readOnly"
             [disabled]="model.readOnly"
             [resultTemplate]="rt"
             [type]="model.inputType"
             [(ngModel)]="currentValue"
             (blur)="onBlur($event)"
             (focus)="onFocus($event)"
             (change)="onChange($event)"
             (input)="onInput($event)"
             (selectItem)="onSelectItem($event)">
      @if (searchFailed) {
        <div class="invalid-feedback">Sorry, suggestions could not be loaded.</div>
      }
    </div>
  </div>
}

@if ((isHierarchicalVocabulary() | async)) {
  <div class="position-relative right-addon">
    <i class="dropdown-toggle position-absolute tree-toggle" (click)="openTree($event)"
       aria-hidden="true"></i>
    <input class="form-control"
           [attr.aria-labelledby]="'label_' + model.id"
           [attr.autoComplete]="model.autoComplete"
           [attr.aria-label]="(model.label || model?.additional?.ariaLabel) | translate"           [class.is-invalid]="showErrorMessages"
           [class.tree-input]="!model.readOnly"
           [id]="id"
           [name]="model.name"
           [placeholder]="model.placeholder"
           [readonly]="true"
           [disabled]="model.readOnly"
           [type]="model.inputType"
           [value]="currentValue?.display"
           (focus)="onFocus($event)"
           (change)="onChange($event)"
           (click)="openTree($event)"
           (keydown)="$event.preventDefault()"
           (keypress)="$event.preventDefault()"
           (keyup)="$event.preventDefault()">
  </div>
}

@if (additionalInfoSelectIsOpen) {
  <div class="bg-white border border-primary position-absolute additional-info-selection">
    <span class="m-2 text-muted">{{'form.other-information.selection.' + otherInfoKey | translate}}</span>
    <ul class="list-unstyled mb-0">
      @for (info of otherInfoValues; track info) {
        <ng-container>
          <li [class.font-weight-bold]="(info === otherInfoValue && otherInfoKey !== alternativeNamesKey)  || (info === otherName && otherInfoKey === alternativeNamesKey) || (model.value && info === model.value['display'] && !otherInfoValue && !otherName)" class="list-item d-flex align-items-center p-2" (click)="selectAlternativeInfo(info)">
            {{info}}
          </li>
        </ng-container>
      }
    </ul>
  </div>
}
